import { Product, ProductCustomTag } from '../types';

// Color presets and contrast calculation for unique product tags

export interface TagColorPreset {
  name: string;
  hex: string;
}

export const TAG_COLOR_PRESETS: TagColorPreset[] = [
  { name: 'Coveristic Red', hex: '#E21B24' },
  { name: 'Neon Purple', hex: '#8B5CF6' },
  { name: 'Cyber Teal', hex: '#06B6D4' },
  { name: 'Emerald', hex: '#10B981' },
  { name: 'Amber Gold', hex: '#F59E0B' },
  { name: 'Hot Pink', hex: '#EC4899' },
  { name: 'Electric Blue', hex: '#3B82F6' },
  { name: 'Vibrant Orange', hex: '#F97316' },
  { name: 'Indigo', hex: '#6366F1' },
  { name: 'Matte Black', hex: '#111827' },
  { name: 'Lime Volt', hex: '#84CC16' },
  { name: 'Rose', hex: '#F43F5E' },
];

/**
 * Calculates accessible foreground text color (#FFFFFF or #111111)
 * based on the perceived luminance of the provided hex color.
 */
export function getContrastTextColor(hexColor: string): string {
  if (!hexColor) return '#FFFFFF';
  
  // Clean hex string
  let hex = hexColor.replace('#', '').trim();
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }
  
  if (hex.length !== 6) return '#FFFFFF';

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Perceived brightness formula (ITU-R BT.709)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 150 ? '#111111' : '#FFFFFF';
}

/**
 * Returns all custom tags for a product, prioritizing customTags array
 * while maintaining backward compatibility with single customTag.
 */
export function getProductCustomTags(product?: Product | null): ProductCustomTag[] {
  if (!product) return [];
  if (Array.isArray(product.customTags) && product.customTags.length > 0) {
    return product.customTags.filter(t => Boolean(t && t.text && t.text.trim()));
  }
  if (product.customTag && product.customTag.text && product.customTag.text.trim()) {
    return [product.customTag];
  }
  return [];
}

